export const getMenuOverrides = theme => {
  return {
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: "14px",
          letterSpacing: "0.25px",
          lineHeight: "21px",
          cursor: "pointer"
        },
        secondary: {
          color: theme.palette.primary.dark,
          fontWeight: 500,
          cursor: "auto"
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: theme.palette.primary.dark,
          paddingLeft: "0px",
          paddingRight: "0px",
          minWidth: 180,
          cursor: "auto",
          "&:hover": {
            color: "#4D596E",
            backgroundColor: "transparent"
          },
          "&:active": {
            color: theme.palette.primary.light,
            backgroundColor: "transparent"
          },
          "&.Mui-selected": {
            color: theme.palette.primary.main,
            backgroundColor: "transparent"
          },
          "&.Mui-selected:hover": {
            color: theme.palette.primary.main,
            backgroundColor: "transparent"
          }
        }
      }
    },
    MuiList: {
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.background.elevation2,
          border: "1px solid",
          borderColor: theme.palette.primary.contrastText,
          borderRadius: 8,
          boxShadow: " 0px 2px 8px -2px rgba(0, 0, 0, 0.08)",
          transition: " 0.3s",
          width: "fit-Content",
          padding: "12px 24px",
          alignItems: "flex-start"
        }
      }
    }
  };
};